/// <amd-module name="SuiteCommerce.PhotoGallery"/>
define("SuiteCommerce.PhotoGallery", ["require", "exports", "SuiteCommerce.PhotoGallery.CCT.BaseView", "SuiteCommerce.PhotoGallery.Common.Instrumentation.Helper"], function (require, exports, PhotoGallery_CCT_BaseView_1, Instrumentation_Helper_1) {
    "use strict";
    return {
        mountToApp: function (container) {
            Instrumentation_Helper_1.InstrumentationHelper.initializeInstrumentation(container);
            container.getComponent('CMS').registerCustomContentType({
                id: 'cct_netsuite_photogallerycct',
                view: PhotoGallery_CCT_BaseView_1.PhotoGalleryCCTBaseView,
                options: {
                    container: container,
                },
            });
        },
    };
});
